import React from "react";
import "./NavPage.css";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

function NavPage({ openBurger, setOpenBurger }) {
  const variants = {
    open: {
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    closed: {
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
  };

  const linkVarient = {
    open: {
      y: 0,
      opacity: 1,
    },
    closed: {
      y: -200,
      opacity: 0,
    },
  };
  return (
    <motion.div
      className="nav"
      initial={openBurger ? "closed" : "open"}
      animate={{ opacity: 1 }}
      variants={variants}
    >
      <motion.div
        initial="closed"
        animate="open"
        transition={{
          delay: 0.1,
        }}
        variants={linkVarient}
        exit="closed"
      >
        <Link to="/" className="font-xl">
          <div className="maskContainer">
            <h4 className="original">Home</h4>
            <div className="mask">
              <div className="top">
                <h4 className="upper-text">Home</h4>
              </div>
              <div className="linethrough"></div>
              <div className="bottom">
                <h4 className="upper-text">Home</h4>
              </div>
            </div>
          </div>
        </Link>
      </motion.div>
      
      <motion.div
        initial="closed"
        animate="open"
        transition={{
          delay: 0.15,
        }}
        variants={linkVarient}
        exit="closed"
      >
        <Link to="/projects" className="font-xl">
          <div className="maskContainer">
            <h4 className="original">Projects</h4>
            <div className="mask">
              <div className="top">
                <h4 className="upper-text">Projects</h4>
              </div>
              <div className="linethrough"></div>
              <div className="bottom">
                <h4 className="upper-text">Projects</h4>
              </div>
            </div>
          </div>
        </Link>
      </motion.div>
      
      {/* <motion.div
        initial="closed"
        animate="open"
        transition={{
          delay: 0.2,
        }}
        variants={linkVarient}
        exit="closed"
      >
        <Link to="/articles" className="font-xl">
          <div className="maskContainer">
            <h4 className="original">Articles</h4>
            <div className="mask">
              <div className="top">
                <h4 className="upper-text">Articles</h4>
              </div>
              <div className="linethrough"></div>
              <div className="bottom">
                <h4 className="upper-text">Articles</h4>
              </div>
            </div>
          </div>
        </Link>
      </motion.div> */}

      {/* <motion.div
        initial="closed"
        animate="open"
        transition={{
          delay: 0.25,
        }}
        variants={linkVarient}
        exit="closed"
      >
        <Link to="/services" className="font-xl">
          <div className="maskContainer">
            <h4 className="original">Services</h4>
            <div className="mask">
              <div className="top">
                <h4 className="upper-text">Services</h4>
              </div>
              <div className="linethrough"></div>
              <div className="bottom">
                <h4 className="upper-text">Services</h4>
              </div>
            </div>
          </div>
        </Link>
      </motion.div> */}

      <motion.div
        initial="closed"
        animate="open"
        transition={{
          delay: 0.3,
        }}
        variants={linkVarient}
        exit="closed"
      >
        <Link to="/about" className="font-xl">
          <div className="maskContainer">
            <h4 className="original">About</h4>
            <div className="mask">
              <div className="top">
                <h4 className="upper-text">About</h4>
              </div>
              <div className="linethrough"></div>
              <div className="bottom">
                <h4 className="upper-text">About</h4>
              </div>
            </div>
          </div>
        </Link>
      </motion.div>
    </motion.div>
  );
}

export default NavPage;
